import { Receipt } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#2563eb";
const SEZIONI = [
  { id: "intro", titolo: "Ricevute EasyTrasporto" },
  { id: "singolo", titolo: "Invio singolo" },
  { id: "massivo", titolo: "Invio massivo" },
  { id: "filtro", titolo: "Filtro 'Solo da inviare'" },
  { id: "contatore", titolo: "Contatore 'Inviate oggi'" },
  { id: "faq", titolo: "FAQ" },
];

export default function ManualeEasyTrasporto() {
  return (
    <ManualeLayout titolo="EasyTrasporto — Ricevute" sottotitolo="Emissione e invio delle ricevute ai beneficiari" icona={Receipt} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="Ricevute EasyTrasporto" accent={A}>
        <P>La sezione <b>Ricevute</b> elenca le ricevute emesse, con ricerca per beneficiario o numero. Ogni ricevuta può essere inviata via email al beneficiario in formato PDF.</P>
      </Scheda>

      <Scheda id="singolo" n="2" titolo="Invio singolo" accent={A}>
        <Steps items={[
          "Individua la ricevuta nell'elenco.",
          "Usa il pulsante 'Invia' sulla riga per spedirla all'email del beneficiario.",
          "Lo stato passa da 'Da inviare' a 'Inviata'. Puoi comunque reinviarla in caso di smarrimento o spam.",
        ]} />
      </Scheda>

      <Scheda id="massivo" n="3" titolo="Invio massivo" accent={A}>
        <Steps items={[
          "Seleziona le ricevute con le caselle a sinistra (o 'seleziona tutto' in testata).",
          "Compare la barra azioni: clicca 'Invia N selezionate'.",
          "Le ricevute senza email vengono saltate; a fine invio ricevi il riepilogo.",
        ]} />
        <Callout tipo="warn">Per non finire nello spam, è consigliato <b>non superare 10–15 invii al giorno</b>. Distribuisci gli invii su più giorni se hai molte ricevute.</Callout>
      </Scheda>

      <Scheda id="filtro" n="4" titolo="Filtro 'Solo da inviare'" accent={A}>
        <P>Il selettore <b>Tutte / Solo da inviare</b> in alto filtra rapidamente le ricevute non ancora spedite. Con 'Solo da inviare' anche 'seleziona tutto' agisce solo su quelle pendenti, riducendo il rischio di invii doppi.</P>
      </Scheda>

      <Scheda id="contatore" n="5" titolo="Contatore 'Inviate oggi'" accent={A}>
        <P>Il badge <b>Inviate oggi: N/15</b> tiene traccia degli invii della giornata e diventa <b>rosso</b> al raggiungimento del limite consigliato, come promemoria anti-spam.</P>
      </Scheda>

      <Scheda id="faq" n="6" titolo="FAQ" accent={A}>
        <FAQ items={[
          { q: "Posso reinviare una ricevuta già inviata?", a: "Sì: il pulsante 'Invia' resta disponibile su ogni riga, utile se il beneficiario l'ha smarrita o è finita in spam." },
          { q: "Alcune ricevute non vengono inviate", a: "Vengono saltate le ricevute prive di indirizzo email; le trovi nel riepilogo a fine invio." },
          { q: "Perché il consiglio di max 10–15 al giorno?", a: "Volumi elevati in poco tempo aumentano il rischio che le email finiscano nello spam del provider." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
